import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { DialogState } from 'app/pages/side-panel/side-panel.types';
import {
  FileLabel,
  FilePropertyOption,
  LabelOption,
  LabelType,
  Property,
  PropertyOption,
  TagDatamart,
} from 'app/types';

@Component({
  selector: 'side-panel-tags',
  templateUrl: './side-panel-tags.component.html',
  styleUrl: './side-panel-tags.component.scss',
})
export class SidePanelTagsComponent implements OnChanges {
  @Input() loading: boolean = false;
  @Input() confidentiality?: string = undefined;
  @Input() tags?: TagDatamart[] = [];
  @Input() locked?: boolean = false;
  @Input() hasRights: boolean = false;
  @Input() customProperties?: FileLabel[] = [];
  @Input() suggestedProperties?: any[] = [];
  @Input() properties?: Property[] = [];
  @Output() editPropertiesCallback = new EventEmitter();
  @Output() ignoreSuggestedTagCallback = new EventEmitter<
    TagDatamart | undefined
  >();
  @Output() ignoreSuggestedPropertyCallback = new EventEmitter<
    Property | undefined
  >();
  @ViewChild('tagsList') tagsList: ElementRef | undefined;

  readonly DialogState = DialogState;
  displayAllProperties: boolean = false;
  suggestedPropertiesLabels: any[] = [];

  constructor() {}

  ngOnChanges() {
    this.customProperties = this.customProperties?.filter(
      (fileLabel) => fileLabel.label.type === LabelType.CUSTOM,
    );
    this.suggestedPropertiesLabels =
      this.suggestedProperties?.map((property: any) => {
        return {
          type: property.type,
          property_id: property.property_id,
          property_option_id: property.property_option_id,
          name:
            property.type === 'PERSON'
              ? property.email
              : this.getOptionNameFromId(
                  property.property_option_id,
                  property.property_id,
                ),
        };
      }) ?? [];
  }

  getOptionNameFromId(optionId: string, propertyId: string) {
    const property = this.properties?.find((property: any) => {
      return property.id === propertyId;
    });
    const label = property?.options?.find((option: any) => {
      return option.id === optionId;
    });
    return label?.name;
  }

  hasNoProperty() {
    return (
      !this.confidentiality &&
      !this.tags?.length &&
      !this.suggestedPropertiesLabels.length &&
      !this.customProperties?.length
    );
  }

  ignoreSuggestedTag(tag: TagDatamart | undefined) {
    this.ignoreSuggestedTagCallback.emit(tag);
  }

  ignoreSuggestedProperty(property: any | undefined) {
    this.ignoreSuggestedPropertyCallback.emit(property);
  }

  getSelectedOption(fc: FilePropertyOption, customLabel: PropertyOption) {
    return customLabel.options?.filter((option: LabelOption) => {
      return fc.property_option_ids.includes(option.id);
    });
  }

  isTagViewExpandable() {
    const tagList = this.tagsList;

    if (!tagList) return false;
    const tagListElement = tagList.nativeElement;
    return (
      tagListElement.scrollHeight > tagListElement.clientHeight ||
      this.displayAllProperties
    );
  }
}
